import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import TickIcon from '../../assets/svgs/tick.svg';

const CheckListItemContainer = styled.div`
  padding: ${p => p.theme.spacing(0.5)} 0;
  display: flex;
  align-items: flex-start;

  :first-child {
    padding: 0 0 ${p => p.theme.spacing(0.5)};
  }

  :last-child {
    padding: ${p => p.theme.spacing(0.5)} 0 0;
  }
`;

const CheckListItemContent = styled.div`
  padding-left: ${p => p.theme.spacing(2)};
`;
const IconContainer = styled.div`
  min-width: ${p => p.theme.spacing(2)};
  min-height: ${p => p.theme.spacing(2)};
  width: ${p => p.theme.spacing(2)};
  height: ${p => p.theme.spacing(2)};
  margin-top: ${p => p.theme.spacing(0.5)};
`;

const CheckListItem = props => {
  return (
    <CheckListItemContainer>
      <IconContainer>
        <TickIcon />
      </IconContainer>
      <CheckListItemContent>{props.children}</CheckListItemContent>
    </CheckListItemContainer>
  );
};

CheckListItem.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
};

export default CheckListItem;
